export default {
  data() {
    return {
      filterErrors: {},
    }
  },
  created() {
    this._filterTimers = {}
  },
  methods: {
    filterState(key) {
      return this.filterErrors[key] ? false : null
    },
    filterFeedback(key) {
      return this.filterErrors[key] || ''
    },
    validateFilter(key, value) {
      if (this._filterTimers[key]) clearTimeout(this._filterTimers[key])
      this._filterTimers[key] = setTimeout(() => {
        if (value === '' || value === null || value === undefined) {
          this.$set(this.filterErrors, key, '')
          return
        }
        const str = String(value)
        const hint = 'Format: comma-separated values. Use * for all, -value to exclude. Example: *,-Bad,Good'
        if (str.startsWith(',') || str.endsWith(',')) {
          this.$set(this.filterErrors, key, 'Remove leading or trailing commas. ' + hint)
          return
        }
        const tokens = str.split(',')
        for (const token of tokens) {
          if (token.trim() === '') {
            this.$set(this.filterErrors, key, 'Remove empty entries (double commas). ' + hint)
            return
          }
          if (token.trim() === '-') {
            this.$set(this.filterErrors, key, 'Exclusion entries need a value after the dash (e.g. -value). ' + hint)
            return
          }
        }
        this.$set(this.filterErrors, key, '')
      }, 1000)
    },
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.filterErrors = {}
        if (this._filterTimers) {
          Object.values(this._filterTimers).forEach(t => clearTimeout(t))
          this._filterTimers = {}
        }
      }
    }
  },
  beforeDestroy() {
    if (this._filterTimers) {
      Object.values(this._filterTimers).forEach(t => clearTimeout(t))
    }
  }
}
